import React from 'react';
import { Grid } from '@mui/material';

import { Supplier } from '../../../models/supplier.model';
import SupplierContactCard from '../../../common/supplier-contact-card/SupplierContactCard';

interface ContactsTabsProps {
  supplier: Supplier;
  companyId: number;
  key: string;
}

const ContactsTabs: React.FC<ContactsTabsProps> = ({ supplier, companyId }) => {
  const supplierContacts = supplier?.contacts || [];

  return (
    <>
      <Grid component='div' container wrap='wrap' style={{ rowGap: '16px' }}>
        <Grid
          component='div'
          size={{ xs: 12 }}
          container
          spacing={2}
          style={{ flexDirection: 'column' }}
        >
          {supplierContacts.length > 0 &&
            supplierContacts.map((contact) => (
              <Grid component='div' key={contact.id}>
                <SupplierContactCard contact={contact} companyId={companyId} />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </>
  );
};

export default ContactsTabs;
